import { put, takeLatest } from "redux-saga/effects";
import { postOffLoginWithFaceIdApi } from "store/api/LoginApi";
import { OFF_LOGIN_WITH_FACE_ID_ACTION } from "../../actions/LoginPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postOffLoginWithFaceId(action) {
	yield put(globalAction.openLoadingPage());
	const { onSuccess, onFail } = action.params;

	const res = yield postOffLoginWithFaceIdApi();
	try {
		if (res?.code === 0) {
			onSuccess();
			yield showMessage(false, res?.message);
		} else {
			onFail();
			yield showMessage(true, res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postOffLoginWithFaceIdSaga() {
	yield takeLatest(OFF_LOGIN_WITH_FACE_ID_ACTION, postOffLoginWithFaceId);
}

export default postOffLoginWithFaceIdSaga;
